import React from "react";
import { Button } from "@material-ui/core";
import "./styles.scss";
import { useHistory } from "react-router-dom";
import stringJp from '../../../constants/stringJP';

const ButtonSubmit = () => {

  let history = useHistory();
  const account_id = localStorage.getItem('account_id');
  const company_code = localStorage.getItem('company_code');
  const store_code = localStorage.getItem('store_code');
  const instore_code = localStorage.getItem('instore_code');
  const security_key = localStorage.getItem('security_key');
  const area_code = localStorage.getItem('area_code');
  const timerange_code = localStorage.getItem('timerange_code');
  const purchase_flag = localStorage.getItem("purchase_flag");
  const cart_flag = localStorage.getItem("cart_flag");
  const add_flag = localStorage.getItem("add_flag");

  const handleClick = () => {
    history.push(`/?account_id=${account_id}&company_code=${company_code}&store_code=${store_code}&instore_code=${instore_code}&security_key=${security_key}&area_code=${area_code}&timerange_code=${timerange_code}&purchase_flag=${purchase_flag}&cart_flag=${cart_flag}&add_flag=${add_flag}`);
  };
  
  return (
    <div style={{ margin: "21px 20px", textAlign: "center" }}>
      <div>
        <div>
          <Button
            variant="contained"
            component="span"
            className="button-submit"
            onClick={handleClick}
          >
            <p>{stringJp.label_list_submit_button}</p>
          </Button>
        </div>
      </div>
    </div>
  );
};
export { ButtonSubmit };
